import React, { FC } from 'react'
import { useTrailerCreate } from './TrailerCreate-ViewModel'
import { Shared } from 'ui/shared'
import Grid from '@mui/material/Grid'
import { Form } from 'utils/helpers/form'
import { Controller } from 'react-hook-form'

export const TrailerCreate: FC = () => {
  const vm = useTrailerCreate()
  const { closeModal, form, isLoading, t, trailerSubtypesOptions, selectedTrailerTypeId, leasingCompaniesOptions } = vm
  const { errors, handleSubmit, register, control, trailerTypesOptions, watch } = form

  const forVirtualParking = watch('forVirtualParking', false)

  return (
    <Shared.Card style={{ width: 375, overflowY: 'auto', maxHeight: '100%' }}>
      <form autoComplete="off" onSubmit={handleSubmit}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Shared.CardTitle title={t('title')} />
          </Grid>
          <Grid item xs={12}>
            <Shared.InputField
              name="vin"
              title={t('vin')}
              register={register(Form.required)}
              error={errors.vin?.message}
            />
          </Grid>
          <Grid item xs={12}>
            <Shared.InputField
              name="plate"
              title={t('plate')}
              register={register(Form.required)}
              error={errors.plate?.message}
            />
          </Grid>
          <Grid item xs={12}>
            <Shared.InputField
              name="imei"
              title={t('imei')}
              register={register(Form.required)}
              error={errors.imei?.message}
            />
          </Grid>
          <Grid item xs={12}>
            <Shared.InputField
              name="sim"
              title={t('sim')}
              register={register(Form.combine(Form.required, Form.minLength(4), Form.maxLength(20)))}
              error={errors.sim?.message}
            />
          </Grid>
          <Grid item xs={12}>
            <Shared.InputField
              name="identifyNumber"
              title={t('identifyNumber')}
              register={register(Form.combine(Form.required, Form.minLength(17)))}
              error={errors.identifyNumber?.message}
            />
          </Grid>
          <Grid item xs={12}>
            <Shared.Dropdown
              control={control}
              name={'trailerTypeId'}
              label={t('trailerTypeId')}
              options={trailerTypesOptions}
              marginTop={0}
              fullWidth
              rules={Form.required}
              error={errors.trailerTypeId?.message}
            />
          </Grid>

          {selectedTrailerTypeId ? (
            <Grid item xs={12}>
              <Shared.Dropdown
                control={control}
                name={'trailerSubtypeId'}
                label={t('trailerSubtypeId')}
                options={trailerSubtypesOptions}
                marginTop={0}
                fullWidth
                rules={Form.required}
                error={errors.trailerSubtypeId?.message}
              />
            </Grid>
          ) : (
            <></>
          )}

          <Grid item xs={12}>
            <Shared.InputField
              name="idHigh"
              title={t('idHigh')}
              register={register(Form.required)}
              error={errors.idHigh?.message}
            />
          </Grid>

          <Grid item xs={12}>
            <Shared.InputField
              name="idLow"
              title={t('idLow')}
              register={register(Form.required)}
              error={errors.idLow?.message}
            />
          </Grid>

          <Grid item xs={12}>
            <Shared.MultiOrganization
              type={'form'}
              showTitle={false}
              control={control}
              divider={false}
              hideBorder={false}
              label={t('organization')}
              watch={watch}
            />
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Shared.InputField
            name="contractNumber"
            title={t('contractNumber')}
            register={register()}
            error={errors.contractNumber?.message}
          />
        </Grid>

        <Grid item xs={12}>
          <Shared.InputField
            name="purchaseValue"
            title={t('purchaseValue')}
            register={register()}
            error={errors.purchaseValue?.message}
          />
        </Grid>

        <Grid item xs={12}>
          <Shared.InputField
            name="supplier"
            title={t('supplier')}
            register={register()}
            error={errors.supplier?.message}
          />
        </Grid>

        <Grid item xs={12}>
          <Shared.InputField
            name="manufacturingDate"
            title={t('manufacturingDate')}
            register={register()}
            error={errors.manufacturingDate?.message}
          />
        </Grid>

        <Grid item xs={12}>
          <Shared.Dropdown
            name="leasingCompanyId"
            id="leasingCompanyId"
            label={t('leasingCompany')}
            options={leasingCompaniesOptions}
            fullWidth
            control={control}
            error={errors.leasingCompanyId?.message}
            marginTop={0}
          />
        </Grid>

        <Grid item xs={12}>
          <Controller
            name="forVirtualParking"
            control={control}
            defaultValue={false}
            render={(field) => (
              <Shared.Checkbox
                {...field}
                label={t('forVirtualParking')}
                checked={field.value}
                onChange={(e) => field.onChange(e.target.checked)}
                formControlStyles={{ marginTop: 5 }}
              />
            )}
          />
        </Grid>
        {forVirtualParking && (
          <Grid item xs={12}>
            <Shared.InputField
              name="lockCode"
              title={t('lockCode')}
              register={register(Form.required)}
              error={errors.lockCode?.message}
            />
          </Grid>
        )}

        <div>
          <Shared.Button
            style={{ margin: '1.875em 0 0.875em 0' }}
            color={'secondary'}
            title={t('cancel')}
            onClick={closeModal}
          />
          <Shared.Button title={t('submit')} type={'submit'} />
        </div>
      </form>

      {isLoading && <Shared.Preloader mask />}
    </Shared.Card>
  )
}
